import { jarallax, jarallaxElement } from 'jarallax';

export default () => {
  jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.3
  });
};
